import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import replaceText from 'components/ttb-home/util'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import PartialListBlock from 'components/ttb-home/ttb-faq/partial-list-block/'

const ContentBodyBlock = ({
  contentData: { isLastBlock, listBlock, paragraphBlock, question },
  t,
}) => {
  // will be move to firebase remote config later (?)
  const ttbItemLimitFlagValue = 8 // 'TTBConfig-20220927'

  return (
    <div
      className={clsx('ttb-faq__content-block', isLastBlock && 'section-end')}
    >
      <span className={clsx('ttb-faq__content-subtitle', Typo.subtitle1)}>
        {hasLocizeTranslation(t, question.disabledKey, question.value)}
      </span>
      {paragraphBlock ? (
        <span className={clsx('ttb-faq__content-body', Typo.price2)}>
          {replaceText(t, paragraphBlock, ttbItemLimitFlagValue)}
        </span>
      ) : (
        <PartialListBlock listData={listBlock} />
      )}
    </div>
  )
}

ContentBodyBlock.propTypes = {
  contentData: PropTypes.shape({
    isLastBlock: PropTypes.bool,
    listBlock: PropTypes.shape({}),
    paragraphBlock: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
    question: PropTypes.shape({
      disabledKey: PropTypes.string,
      nonTTBHDisabled: PropTypes.bool,
      value: PropTypes.string,
    }),
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ContentBodyBlock)
